(() => {
  if (customElements.get('mp-promo-carousel')) return;

  class PromoCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.track = this.querySelector('.mp-promo__track');
      this.button = this.querySelector('.mp-promo__next');

      if (!this.track || !this.button) return;

      this.controller?.abort();
      this.observer?.disconnect();

      this.controller = new AbortController();

      const options = {
        signal: this.controller.signal
      };

      this.button.addEventListener(
        'click',
        () => this.advance(),
        options
      );

      this.track.addEventListener(
        'scroll',
        () => this.updateLabel(),
        {
          ...options,
          passive: true
        }
      );

      window.addEventListener(
        'resize',
        () => this.update(),
        options
      );

      this.classList.add('is-ready');
      this.update();

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.update());

        this.observer.observe(this);
        this.observer.observe(this.track);

        const firstCard = this.track.querySelector('.mp-promo__card');

        if (firstCard) {
          this.observer.observe(firstCard);
        }
      }
    }

    update() {
      /*
       * Comparar el contenido con el ancho completo del carrusel,
       * sin descontar el espacio de la flecha.
       */
      const contentWidth = this.track.scrollWidth;
      const fullWidth = this.clientWidth;
      const hasOverflow = contentWidth > fullWidth + 2;

      this.classList.toggle('is-scrollable', hasOverflow);
      this.button.hidden = !hasOverflow;

      this.updateLabel();
    }

    distanceFromStart() {
      return Math.abs(this.track.scrollLeft);
    }

    atEnd() {
      return this.distanceFromStart() >=
        this.track.scrollWidth - this.track.clientWidth - 4;
    }

    updateLabel() {
      const atEnd = this.atEnd();

      const label = atEnd
        ? (this.dataset.startLabel || 'Volver al primer producto')
        : (this.dataset.nextLabel || 'Ver siguiente producto');

      this.button.setAttribute('aria-label', label);
      this.button.title = label;
      this.button.classList.toggle('is-at-end', atEnd);
    }

    advance() {
      const card = this.track.querySelector('.mp-promo__card');

      if (!card) return;

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const behavior = reducedMotion ? 'auto' : 'smooth';

      if (this.atEnd()) {
        this.track.scrollTo({
          left: 0,
          behavior
        });

        return;
      }

      const gap = parseFloat(
        getComputedStyle(this.track).columnGap
      ) || 0;

      const step = card.getBoundingClientRect().width + gap;

      const direction =
        getComputedStyle(this.track).direction === 'rtl'
          ? -1
          : 1;

      this.track.scrollBy({
        left: step * direction,
        behavior
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  }

  customElements.define('mp-promo-carousel', PromoCarousel);
})();
